export const checklistData = {
    bedroom: {
        title: "Спальня",
        items: [
            "Вещи аккуратно сложены",
            "Кровать заправлена",
            "Все открытые поверхности протёрты (тумбочки,полки шкафов,обод кровати)",
            "Пол был пропылесошен и вымыт (под кроватью,за прикроватными тумбами,в углах)",
            "Ручки дверей, выключатели и розетки протёрты",
            "Подоконники и верх батареи протёрты",
            "Зеркальные поверхности натёрты",
        ],
        photos: [
            "Общая фотография спальни",
            "Фото угла комнаты",
            "Фото поверхности (тумбочка/полка)",
            "Фото под мебелью",
        ],
    },
    livingroom: {
        title: "Гостиная",
        items: [
            "Вещи аккуратно сложены",
            "Все открытые поверхности протёрты",
            "Диван был пропылесошен",
            "Розетки, выключатели и дверные ручки были протёрты",
            "Пол был пропылесошен и вымыт (в углах,под диваном)",
            "Подоконники и верх батареи протёрты",
            "Зеркальные поверхности натёрты",
        ],
        photos: [
            "Общая фотография гостиной",
            "Фото зоны скапливания пыли",
            "Фото дивана",
            "Фото поверхности (стол, полка)",
        ],
    },
    kitchen: {
        title: "Кухня",
        items: [
            "Грязная посуда сложена в посудомоечную машину",
            "Столешница протёрта",
            "Кухонная техника протёрта (чайник,кофемашина,тостерница и т.д)",
            "Кухонный смеситель натёрт",
            "Раковина была вымыта",
            "Кухонный рукав натёрт",
            "Все открытые поверхности протёрты (столы,стулья)",
            "Пол был пропылесошен и вымыт",
            "Зеркальные поверхности натёрты",
        ],
        photos: [
            "Общий вид кухни",
            "Фото смесителя и раковины",
            "Фото основных поверхностей",
            "Фото пола в зоне скопления мусора",
        ],
    },
    bathroom: {
        title: "Ванная / Туалет",
        items: [
            "Мусор был убран",
            "Пол был пропылесошен или крупный сор был собран",
            "Коврик был почищен",
            "Плитка вокруг ванны была помыта",
            "Ванна/душевая кабина были почищены",
            "Смесители были очищены",
            "Зеркала были протёрты",
            "Унитаз был почищен",
            "Раковина была вымыта",
            "Все открытые поверхности были протёрты",
            "Полотенца были аккуратно сложены",
            "Пол был помыт",
        ],
        photos: [
            "Общая фотография ванной",
            "Фото унитаза и смесителя",
            "Фото ванны/душевой кабины",
            "Фото зеркал/стеклянных поверхностей",

        ],
    },
    hallway: {
        title: "Прихожая",
        items: [
            "Верхняя одежда развешена, обувь расставлена",
            "Коврик был почищен",
            "Зеркала были натёрты",
            "Выключатели и розетки  протёрты",
            "Плинтусы протёрты",
            "Пол пропылесошен и вымыт",
        ],
        photos: [
            "Общая фотография прихожей",
            "Фото чистого коврика или пола",
        ],
    },
};